export var Roles;
(function (Roles) {
    Roles[Roles["Admin"] = 1] = "Admin";
    Roles[Roles["Manager"] = 2] = "Manager";
    Roles[Roles["Staff"] = 3] = "Staff";
    Roles[Roles["Owner"] = 4] = "Owner";
    Roles[Roles["Finance"] = 5] = "Finance";
    Roles[Roles["Terminal"] = 6] = "Terminal";
})(Roles || (Roles = {}));
